
export const FEATURE_PATTERNS = [
  { name: "ALO", pattern: /(?:^|,)\s*alo-\s*(?:,|$)/i },
  { name: "FlexTune", pattern: /(?:^|,)\s*flextune-\s*(?:,|$)/i },
  { name: "MultiConfigMode", pattern: /(?:^|,)\s*multiconfigmode-\s*(?:,|$)/i },
  { name: "AOC", pattern: /(?:^|,)\s*aoc-\s*(?:,|$)/i },
  { name: "CLO", pattern: /(?:^|,)\s*clo-\s*(?:,|$)/i, exclude: /(?:^|,)\s*clolite-\s*(?:,|$)/i },
  { name: "CLOLite", pattern: /(?:^|,)\s*clolite-\s*(?:,|$)/i },
  { name: "AST", pattern: /(?:^|,)\s*ast-\s*(?:,|$)/i },
  { name: "Luminaire Info", pattern: /\bluminfoformat\d*\b/i, unique: true },
  { name: "DALI PSU", pattern: /(?:^|,)\s*srpsu-\s*(?:,|$)/i },
  { name: "DALI PSU", pattern: /(?:^|,)\s*dalipsu-\s*(?:,|$)/i, unique: true },
  { name: "DALI 102 Addressing ", pattern: /(?:^|,)\s*daliaddressing102-[^,]*/i},
  { name: "DALI 102 and 207 Configuration", pattern: /(?:^|,)\s*daliconfiguration102and207-[^,]*/i},
  { name: "AUX Output Voltage", pattern: /(?:^|,)\s*aux-\s*(?:,|$)/i, unique: true },
  { name: "LSI", pattern: /(?:^|,)\s*lsi-\s*(?:,|$)/i, unique: true },
  { name: "AOC M-Ch", pattern: /(?:^|,)\s*aocmultichannel-\s*(?:,|$)/i, unique: true},
  { name: "OTP", pattern: /(?:^|,)\s*otp-\s*(?:,|$)/i, unique: true },
  { name: "DSC", pattern: /(?:^|,)\s*dsc-\s*(?:,|$)/i, unique: true },
  { name: "Low Mains Lock", pattern: /(?:^|,)\s*lowmainslock-\s*(?:,|$)/i, unique: true },
  { name: "DIPSwitch", pattern: /(?:^|,)\s*dipswitch-\s*(?:,|$)/i, unique: true },
  { name: "ZTV", pattern: /(?:^|,)\s*ztv-[^,]*/i },
  { name: "Dynadimmer", pattern: /(?:^|,)\s*dynadimmer-\s*(?:,|$)/i },
  { name: "Line Switch", pattern: /(?:^|,)\s*lineswitch-\s*(?:,|$)/i },
  { name: "Amp Dim", pattern: /(?:^|,)\s*ampdim-\s*(?:,|$)/i },
  { name: "DC Emergency", pattern: /(?:^|,)\s*dcemergency-\s*(?:,|$)/i },
  { name: "DTL", pattern: /(?:^|,)\s*dtl-[^,]*/i },
  { name: "MTP", pattern: /(?:^|,)\s*mtp-[^,]*/i },
  { name: "Min Dim Level", pattern: /(?:^|,)\s*mindimlevel-[^,]*/i },
  { name: "Touch Dim", pattern: /(?:^|,)\s*touchdim-[^,]*/i },
  { name: "Corridor", pattern: /(?:^|,)\s*corridor-[^,]*/i },
  { name: "RSO", pattern: /(?:^|,)\s*rso-[^,]*/i },
  { name: "LIP", pattern: /(?:^|,)\s*lip-[^,]*/i },
  { name: "ZTV Output", pattern: /(?:^|,)\s*ztvoutput-[^,]*/i },
  { name: "Coded Mains", pattern: /(?:^|,)\s*codedmains-[^,]*/i },
  { name: "Coded Light", pattern: /(?:^|,)\s*codedlight-[^,]*/i },
  { name: "DALI 253M", pattern: /(?:^|,)\s*diia253maintenance-[^,]*/i },
  { name: "OWP", pattern: /(?:^|,)\s*owp-[^,]*/i },
  { name: "Dimming Interface", pattern: /(?:^|,)\s*dimminginterface-[^,]*/i },
  { name: "Unsupported", pattern: /(?:^|,)\s*unsupported[^,]*/i },
];

export const FEATURE_NORMALIZATION: { [key: string]: string } = {
  "luminaire info": "Luminaire Info",
  "luminfoformat": "Luminaire Info",
  "dcemergency": "DC Emergency",
  "ampdim": "Amp Dim",
  "lineswitch": "Line Switch",
  "mindimlevel": "Min Dim Level",
  "codedmains": "Coded Mains",
  "codedlight": "Coded Light",
  "touchdim": "Touch Dim",
  "corridor": "Corridor",
  "diia253maintenance": "DALI 253M",
  "dynadimmer": "Dynadimmer",
  "mtp": "MTP",
  "dalipsu": "DALI PSU",
  "daliaddressing102": "DALI 102 Addressing",
  "daliconfiguration102and207": "DALI 102 and 207 Configuration",
  "aux": "AUX Output Voltage",
  "lsi": "LSI",
  "aocmultichannel": "AOC M-Ch",
  "otp": "OTP",
  "dsc": "DSC",
  "lowmainslock": "Low Mains Lock",
  "dipswitch": "DIPSwitch",
  "flextune": "FlexTune",
  "multiconfigmode": "MultiConfigMode",
  "owp": "OWP",
  "ztvoutput": "ZTV Output",
  "alo": "ALO",
  "aoc": "AOC",
  "dtl": "DTL",
  "clo": "CLO",
  "clolite": "CLOLite",
  "ast": "AST",
  "srpsu": "DALI PSU",
  "ztv": "ZTV",
  "rso": "RSO",
  "lip": "LIP",
  "dimminginterface": "Dimming Interface",
  "unsupported": "Unsupported",
};
